import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import config from '../../assets/config.json';
import { StorageService } from './storage.service';
import { map } from 'rxjs/operators';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { timeout } from 'rxjs/operators'
import { CommonService } from './common.service';
var CryptoJS = require("crypto-js");
import cookies from 'js-cookie';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  // "client_Url": "https://cxc.tcscognixsit.com/",
  // "sso_flag": true,
  public configvalue = config.inputvalue;
  // public encvalue = key;
  apiURL_Core: string = config.apiURL_Core;
  initial_Process_Name: string = config.initial_Process;
  ssoLoginValidate: string = config.sso_Authenticate_Url;
  /// public client_Url: string = config.client_Url;
  public sso: boolean = config.sso;
  public sso_flag: boolean = config.sso_flag;
  ImprovementCategoryRequired = config.ImprovementCategoryRequired;
  //public initiator_Role: string = config.initiator_Role;
  // public sso_flag : boolean = config.sso_flag;
  //apiURL_Core: string =  "/workflow-api/";
  apiURL_Authentication: string = config.apiURL_Authentication;
  Authentication_Type: string = config.Authentication_Type;
  Mandatory_To_Encrypt_PD: string = config.Mandatory_To_Encrypt_PD;

  public is_middleware_required: boolean = config.is_middleware_required;
  public middleware_url: string = config.middleware_url;
  public is_sso: boolean = config.is_sso;
  public sso_url: string = config.sso_url;
  //public is_sso: boolean = config.sso_flag;
  public session_timeout_interval = config.session_timeout_interval;
  public next_transaction_count = config.next_transaction_count;

  public allow_multiple_emailid_in_to_email_section = false;
  public Bulk_Upload_File_Count = config.Bulk_Upload_File_Count;
  public Enable_Update_data_Module_Next_queue = config.Enable_Update_data_Module_Next_queue;
  // public piicheckurl = config.wisdomnexturl
  // public piiagenturl = config.piiagenturl
  public piiagenturl = '';
  public piicheckurl ='';



  constructor(private _http: HttpClient, private storageService: StorageService, private encryptDecrypt: EncryptDecryptService,private encryptDecryptservice :EncryptDecryptService, private memorystore: MemoryStorageService) {
    this.getConfigData();
  }
private ClientSideValidation(text: any): boolean {
  const whiteListRegex = "^[a-zA-Z0-9_ .-]+$";// Allow only alphanumeric, underscores, spaces, dots, and hyphens
  var strfilename = String(text);
  var regex = new RegExp(whiteListRegex);
  return regex.test(strfilename);
}
  getConfigData() {
    fetch('./assets/config.json').then(res => res.json())
      .then(data => {
        this.sso_flag = config.sso_flag;
        this.ssoLoginValidate = config.sso_Authenticate_Url;
        this.apiURL_Core = data.apiURL_Core;
        this.apiURL_Authentication = data.apiURL_Authentication;
        this.Authentication_Type = data.Authentication_Type;
        this.Mandatory_To_Encrypt_PD = data.Mandatory_To_Encrypt_password;
        this.is_middleware_required = data.is_middleware_required;
        this.middleware_url = data.middleware_url;
        this.is_sso = data.is_sso;
        this.sso_url = data.sso_url;
        this.session_timeout_interval = data.session_timeout_interval;
        this.next_transaction_count = data.next_transaction_count;
        this.allow_multiple_emailid_in_to_email_section = data.allow_multiple_emailid_in_to_email_section;
        this.initial_Process_Name = data.initial_Process;
        this.ImprovementCategoryRequired = data.ImprovementCategoryRequired;
        if (this.allow_multiple_emailid_in_to_email_section == undefined)
          this.allow_multiple_emailid_in_to_email_section = false;

        this.Bulk_Upload_File_Count = config.Bulk_Upload_File_Count;
        this.Enable_Update_data_Module_Next_queue = config.Enable_Update_data_Module_Next_queue;

      });
  }

  getData(apiMethod: string, params?: any, apiRoute: string = this.apiURL_Core): Observable<any> {
    if (!this.ClientSideValidation(apiMethod)) {
      throw new Error(`Invalid API method: ${apiMethod}`);
    }
    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.encryptDecrypt.encryptUsingAES256(this.storageService.secureStorage.getItem('userId'));
    // let authtoken = this.storageService.secureStorage.getItem('authtoken');
    let _token = this.memorystore.getItem('token');
    let _userId =this.memorystore.getItem('userId');
    let authtoken = this.memorystore.getItem('authtoken');
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (params == null)
        params = new HttpParams();

      //pwm_id is userId(renamed due to web inspect issue fix)
      // if (params.hasOwnProperty('updates')) {
      //   // params = params.append('token', _token);
      //   params = params.append('pwm_id', _userId);
      // } else {
      //   // params['token'] = _token;
      //   params['pwm_id'] = this.encryptDecrypt.encryptUsingAES256(_userId);
      // }

      // params = params.append('xusrid', _userId);
      // params['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId);//added by Jeyakumar 01-04-2026
    }
    let header = this.getHeader(apiRoute);
    return this._http.get(apiRoute + apiMethod, { headers: header, params: params, withCredentials: false }).pipe(
      catchError(this.handleError));
    // if (apiMethod == "header_logo_Image_Path") {
    //   let header = this.getHeaderauth(apiRoute)
    //   return this._http.get(apiRoute + apiMethod, { headers: header, params: params, withCredentials: false }).pipe(
    //     catchError(this.handleError));
    // } else {
    //   let header = this.getHeader(apiRoute);
    //   return this._http.get(apiRoute + apiMethod, { headers: header, params: params, withCredentials: false }).pipe(
    //     catchError(this.handleError));
    // }
   
  }

  getData1(apiMethod: string, params?: any, apiRoute: string = this.apiURL_Core): Promise<any> {

    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId');
    // let authtoken = this.storageService.secureStorage.getItem('authtoken');
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId');
    let authtoken = this.memorystore.getItem('authtoken');
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (params == null)
        params = new HttpParams();

      //pwm_id is userId(renamed due to web inspect issue fix)
      if (params.hasOwnProperty('updates')) {
        params = params.append('token', _token);
        params = params.append('pwm_id', _userId);
      } else {
        params['token'] = _token;
        params['pwm_id'] = _userId;
      }

    }
    let header = this.getHeader(apiRoute);
    return this._http.get(apiRoute + apiMethod, { headers: header, params: params, withCredentials: false })
      .toPromise().then(res => {
        return this.decryptResponse(res, apiMethod);
        return res;
      }).catch(this.handleError);
  }

  decryptResponse(res, apiMethod) {

    let decryptedString = this.encryptDecrypt.decryptUsingAES256(res);
    try {
      return JSON.parse(decryptedString);
    } catch (error) {
      if (typeof (decryptedString) === "string")
        return decryptedString;
      else
        return "";
    }
  }

  async getDataPromise(apiMethod: string, params?: any, apiRoute: string = this.apiURL_Core): Promise<any> {

    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId')
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (params == null)
        params = new HttpParams();

      if (params.hasOwnProperty('updates')) {
        params = params.append('token', _token);
        // params = params.append('pwm_id', _userId);
        // params = params.append('pwm_id', this.encryptDecrypt.encryptUsingAES256(_userId));
      } else {
        params['token'] = _token;
        // params['pwm_id'] = this.encryptDecrypt.encryptUsingAES256(_userId);
      }
    }
    
      // params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(_userId));//Added by jeyakumar 01-04-2026    
       params['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId);

    let header = this.getHeader(apiRoute);
    return this._http.get(apiRoute + apiMethod, { headers: header, params: params, withCredentials: false }).toPromise().then(res => {
      return res;
    }).catch(this.handleError);
  }

  postData(apiMethod: string, body: any, apiRoute: string = this.apiURL_Core): Observable<any> {

    // if (!this.ClientSideValidation(apiMethod)) {
    //   throw new Error(`Invalid API method: ${apiMethod}`);
    // }// let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId')
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (body == null)
        body = {};
      body['token'] = _token;
      body['userId'] = this.encryptDecrypt.encryptUsingAES256(_userId);
      body['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId); //added by jeyakumar 1-04-2026
    }

    let headers = this.getHeader(apiRoute);

    return this._http.post(apiRoute + apiMethod, body, { headers: headers, params: new HttpParams, withCredentials: false })
      .pipe(
        catchError(this.handleError));
  }

  async postDownloadFilePromise(apiMethod: string, body: any, params?: any, apiRoute: string = this.apiURL_Core): Promise<any> {
    // let headers = new HttpHeaders()
    let headers = this.getHeaders(apiRoute);
//Added by imran on 01-04-26
    let _userId = this.memorystore.getItem('userId')
    if (body == null)
        body = {};     
        body['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId);//Added by imran on 01-04-26
    return this._http
      .post(apiRoute + apiMethod, body, {
        headers: headers,
        observe: 'response',
        responseType: 'blob'
      })
      .toPromise().then(res => {
        if (res)
          return res;
        return res;
      }).catch(this.handleError);
  }

  deleteData(apiMethod: string, body: any, params?: any, apiRoute: string = this.apiURL_Core): Observable<any> {

    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId')
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (body == null)
        body = {};
      body['token'] = _token;
      body['userId'] = _userId;
      body['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId);//Added by imran on 01-04-26
    }

    let headers = this.getHeader(apiRoute);

    return this._http.delete(apiRoute + apiMethod, { headers: headers, params: new HttpParams, body: body }).pipe(
      catchError(this.handleError));
  }

  async postFilePromise(apiMethod: string, body: any, params?: any, apiRoute: string = this.apiURL_Core): Promise<any> {
    // let headers = this.getHeader(apiRoute);
    let headers;
    // if (body instanceof FormData)
    //   headers = new HttpHeaders();
    // else
    headers = this.getHeaders(apiRoute);

    return this._http
      .post(apiRoute + apiMethod, body, { headers: headers })
      .toPromise().then(res => {
        if (res)
          return res;
        return res;
      }).catch(this.handleError);
  }
  //Added by Dharshana for PII data check using Wisdomnext(Web side).
  async piiDataCheck(apiMethod: string, body: any, params?: any, apiRoute: string = this.piicheckurl): Promise<any> {
    let headers;
    headers = this.piiheaders(apiRoute);
    return this._http
      .post("/api/" + apiMethod, body, { observe: 'response', headers: headers })
      .pipe(timeout(100000))
      .toPromise().then(res => {
        if (res)
          return res;
        return res;
      }).catch(this.handleError);
  }
  private piiheaders(apiRoute: string): HttpHeaders {
    let headers: HttpHeaders;
    headers = new HttpHeaders().set("X-BUC-ORG-KEY", "YJiN$Tb1[P9x").set("X-BUC-ORG-NAME", "TCS_INTERNAL").set("Access-Control-Allow-Origin", "*");

    return headers;

  }
  //Added by Dharshana for PII data check using Wisdomnext(Web side).

  //Added by Dharshana for PII data check using Wisdomnext(python code).
  async piiDataCheckagent(apiMethod: string, body: any, params?: any, apiRoute: string = this.piiagenturl): Promise<any> {
    let headers;
    // headers = this.piiheaders(apiRoute);
    return this._http
      .post(apiRoute + apiMethod, body, { observe: 'response', headers: headers })
      .pipe(timeout(100000))
      .toPromise().then(res => {
        if (res)
          return res;
        return res;
      }).catch(this.handleError);
  }
  private piiagentheaders(apiRoute: string): HttpHeaders {
    let headers: HttpHeaders;
    headers = new HttpHeaders().set("X-BUC-ORG-KEY", "YJiN$Tb1[P9x").set("X-BUC-ORG-NAME", "TCS_INTERNAL").set("Access-Control-Allow-Origin", "*");

    return headers;

  }
  //Added by Dharshana for PII data check using Wisdomnext(python code).

  private getHeaders(apiRoute: string): HttpHeaders {
    let headers: HttpHeaders;
    //added by dharshana on 23.06.25 for token validation.
    var authtoken = "", user = "",guid="",Userdetail="",userName="",timestamp="",token="",issso = "";
    // if (this.storageService.secureStorage.getItem('authtoken') != undefined && this.storageService.secureStorage.getItem('authtoken') != null) {
    //   authtoken = this.storageService.secureStorage.getItem('authtoken')
    // }
    // if (this.storageService.secureStorage.getItem('userId') != undefined && this.storageService.secureStorage.getItem('userId') != null) {
    //   user = this.storageService.secureStorage.getItem('userId').toString();
    // }
    if (this.memorystore.getItem('authtoken') != undefined && this.memorystore.getItem('authtoken') != null) {
      authtoken = this.memorystore.getItem('authtoken')
    }
    if (this.memorystore.getItem('userId') != undefined && this.memorystore.getItem('userId') != null) {
      user = this.memorystore.getItem('userId').toString();
    }
    if (this.memorystore.getItem('guid') != undefined && this.memorystore.getItem('guid') != null) {
      guid = this.memorystore.getItem('guid')
    }
    if (this.memorystore.getItem('Userdetail') != undefined && this.memorystore.getItem('Userdetail') != null) {
      Userdetail = this.memorystore.getItem('Userdetail').toString();
    }
    if (this.memorystore.getItem('userName') != undefined && this.memorystore.getItem('userName') != null) {
      userName = this.memorystore.getItem('userName')
    }
    if (this.memorystore.getItem('timestamp') != undefined && this.memorystore.getItem('timestamp') != null) {
      timestamp = this.memorystore.getItem('timestamp').toString();
    }
    if (this.memorystore.getItem('token') != undefined && this.memorystore.getItem('token') != null) {
      token = this.memorystore.getItem('token')
    }  
    if(this.is_sso){
      issso = "true";
    }else{
      issso = "false";
    }
    //added by dharshana on 23.06.25 for token validation.
    headers = new HttpHeaders().set("Cache-Control", "no-store,no-cache, must-revalidate").set("Content-Security-Policy", "default-src:self,script-src:self,object-src:self,font-src:self,style-src:self,img-src:self,frame-src:self,connect-src:self,media-src:self,frame-ancestors:none,child-src:none,form-action:none,report-uri:self,report-to:self;").set("Strict-Transport-Security", "max-age=31536000; includeSubDomains;preload").set("X-Content-Type-Options", "nosniff").set("authtoken", authtoken).set("user_id", user)
    .set("guid",guid).set("Userdetail",Userdetail).set("userName",userName).set("ts",timestamp).set("clienttoken",token).set("issso",issso);
    return headers;

  }
  async postDataPromise(apiMethod: string, body: any, param?: any, apiRoute: string = this.apiURL_Core): Promise<any> {

    if (!this.ClientSideValidation(apiMethod)) {
      throw new Error(`Invalid API method: ${apiMethod}`);
    }
    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId')
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (body == null)
        body = {};
      body['token'] = _token;
      body['xusrid'] = this.encryptDecryptservice.encryptUsingAES256(_userId);//Added by Jeyakumar on 01-04-26
      // body['userId'] = _userId;
    }
    let header = this.getHeader(apiRoute);

    return this._http.post(apiRoute + apiMethod, body, { headers: header, params: param, withCredentials: false }).toPromise().then(res => {
      return res;
    }).catch(this.handleError);
  }

  // postRealTimeAPI(apiUrl: string, body: any, params?: any, headers: string = ''): Observable<any> {

  //   let _token = this.storageService.secureStorage.getItem('token');
  //   let _userId = this.storageService.secureStorage.getItem('userId')
  //   if (_token != undefined) {
  //     _token = _token == null ? "" : _token;
  //     if (body == null)
  //       body = {};
  //     body['token'] = _token;
  //     body['userId'] = _userId;
  //   }
  //   let header = this.getHeader('realtime');
  //   return this._http.post(apiUrl, body, { headers: header, params: new HttpParams }).pipe(
  //     catchError(this.handleError));
  // }

  // getRealTimeAPI(apiUrl: string, params?: any, headers: string = ''): Observable<any> {

  //   // let _token = this.storageService.secureStorage.getItem('token');
  //   // let _userId = this.storageService.secureStorage.getItem('userId')
  //   // if (_token != undefined) {
  //   //   _token = _token == null ? "" : _token;
  //   // if (params.hasOwnProperty('updates')) {
  //   //   params = params.append('token', _token);
  //   //   params = params.append('pwm_id', _userId);
  //   // } else {
  //   //   params['token'] = _token;
  //   //   params['pwm_id'] = _userId;
  //   // }
  //   // }

  //   if (params == null)
  //     params = new HttpParams();

  //   let header = this.getHeader('realtime');
  //   return this._http.get(apiUrl, { headers: header, params: params }).pipe(
  //     catchError(this.handleError));
  // }

  async postPromiseRealTimeAPI(api_id: number, body: any, apiRoute: string = this.apiURL_Core): Promise<any> {
    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    // if (_token != undefined) {
    //   _token = _token == null ? "" : _token;
    //   if (body == null)
    //     body = {};
    //   body['token'] = _token;
    //   body['userId'] = _userId;
    // }
    let bodyParam = {
      api_id: api_id,
      bodyParam: JSON.stringify(body)
    }
    let header = this.getHeader('realtime');

    return this._http.post(apiRoute + 'post-realtime-api', bodyParam, { headers: header, params: new HttpParams }).toPromise().then(res => {
      return res;
    }).catch(this.handleError);
  }

  get_realTimeApi(api_id: number, params?: any, apiRoute: string = this.apiURL_Core): Observable<any> {

    let apiParams = new HttpParams();
    apiParams = apiParams.append('api_id', api_id);
    apiParams = apiParams.append('apiParam', JSON.stringify(params));

    let header = this.getHeader('realtime');
    return this._http.get(apiRoute + 'get-realtime-api', { headers: header, params: apiParams }).pipe(
      catchError(this.handleError));
  }

  post_realTimeApi(api_id: number, body: any, apiRoute: string = this.apiURL_Core): Observable<any> {

    let bodyParam = {
      api_id: api_id,
      bodyParam: JSON.stringify(body)
    }
    let header = this.getHeader('realtime');
    return this._http.post(apiRoute + 'post-realtime-api', bodyParam, { headers: header, params: new HttpParams }).pipe(
      catchError(this.handleError));
  }

  getDataFromExteralApi(url: string, params?: any, apiRoute: string = this.apiURL_Core): Observable<any> {

    // let _token = this.storageService.secureStorage.getItem('token');
    // let _userId = this.storageService.secureStorage.getItem('userId')
    let _token = this.memorystore.getItem('token');
    let _userId = this.memorystore.getItem('userId')
    if (_token != undefined) {
      _token = _token == null ? "" : _token;
      if (params == null)
        params = new HttpParams();

      //pwm_id is userId(renamed due to web inspect issue fix)
      if (params.hasOwnProperty('updates')) {
        params = params.append('token', _token);
        params = params.append('pwm_id', _userId);
      } else {
        params['token'] = _token;
        params['pwm_id'] = _userId;
      }

    }
    let header = this.getHeader(apiRoute);
    return this._http.get(url, { headers: header, params: params }).pipe(
      catchError(this.handleError));
  }

  private getHeader(apiRoute: string): HttpHeaders {
    let header: HttpHeaders;
    //added by dharshana on 23.06.25 for token validation.
    var authtoken = "", user = "",guid="",Userdetail="",userName="",timestamp="",token="",issso="";
    // if (this.storageService.secureStorage.getItem('authtoken') != undefined && this.storageService.secureStorage.getItem('authtoken') != null) {
    //   authtoken = this.storageService.secureStorage.getItem('authtoken')
    // }
    // if (this.storageService.secureStorage.getItem('userId') != undefined && this.storageService.secureStorage.getItem('userId') != null) {
    //   user = this.storageService.secureStorage.getItem('userId').toString();
    // }
    if (this.memorystore.getItem('authtoken') != undefined && this.memorystore.getItem('authtoken') != null) {
      authtoken = this.memorystore.getItem('authtoken')
    }
    if (this.memorystore.getItem('userId') != undefined && this.memorystore.getItem('userId') != null) {
      user = this.memorystore.getItem('userId').toString();
    }
    if (this.memorystore.getItem('guid') != undefined && this.memorystore.getItem('guid') != null) {
      guid = this.memorystore.getItem('guid')
    }
    if (this.memorystore.getItem('Userdetail') != undefined && this.memorystore.getItem('Userdetail') != null) {
      Userdetail = this.memorystore.getItem('Userdetail').toString();
    }
    if (this.memorystore.getItem('userName') != undefined && this.memorystore.getItem('userName') != null) {
      userName = this.memorystore.getItem('userName')
    }
    if (this.memorystore.getItem('timestamp') != undefined && this.memorystore.getItem('timestamp') != null) {
      timestamp = this.memorystore.getItem('timestamp').toString();
    }
    if (this.memorystore.getItem('token') != undefined && this.memorystore.getItem('token') != null) {
      token = this.memorystore.getItem('token')
    }    
    if(this.is_sso){
      issso = "true";
    }else{
      issso = "false";
    }
    //added by dharshana on 23.06.25 for token validation.
    header = new HttpHeaders().set("Content-Type", "application/json").set("Cache-Control", "no-store,no-cache, must-revalidate").set("Content-Security-Policy", "default-src:self,script-src:self,object-src:self,font-src:self,style-src:self,img-src:self,frame-src:self,connect-src:self,media-src:self,frame-ancestors:none,child-src:none,form-action:none,report-uri:self,report-to:self;").set("Strict-Transport-Security", "max-age=31536000; includeSubDomains;preload").set("X-Content-Type-Options", "nosniff").set("authtoken", authtoken).set("user_id", user)
    .set("guid",guid).set("Userdetail",Userdetail).set("userName",userName).set("ts",timestamp).set("clienttoken",token).set("issso",issso);
    return header;
  }

  private getHeaderauth(apiRoute: string): HttpHeaders {
    let header: HttpHeaders;
    //added by dharshana on 23.06.25 for token validation.
    var authtoken = "", user = "";    
    if (this.memorystore.getItem('userId') != undefined && this.memorystore.getItem('userId') != null) {
      user = this.memorystore.getItem('userId').toString();
    }
    //added by dharshana on 23.06.25 for token validation.
    header = new HttpHeaders().set("Content-Type", "application/json").set("Cache-Control", "no-store,no-cache, must-revalidate").set("Content-Security-Policy", "default-src:self,script-src:self,object-src:self,font-src:self,style-src:self,img-src:self,frame-src:self,connect-src:self,media-src:self,frame-ancestors:none,child-src:none,form-action:none,report-uri:self,report-to:self;").set("Strict-Transport-Security", "max-age=31536000; includeSubDomains;preload").set("X-Content-Type-Options", "nosniff").set("authtoken", authtoken).set("user_id", user);
    return header;
  }
  // ssologinValidate(): Observable<any> {
  //   var data = {
  //     userId: sessionStorage.getItem('userId'),
  //     userName: sessionStorage.getItem('userName'),
  //     ts: sessionStorage.getItem('timestamp'),
  //     action: sessionStorage.getItem('action'),
  //     //contextName: sessionStorage.getItem('context'),
  //     guid: sessionStorage.getItem('guid'),
  //     // token: sessionStorage.getItem('token')
  //   }
  //   let header = this.getHeader(this.apiURL_Core);
  //   return this._http.post<any>(this.apiURL_Core + 'SSOValidateauthToken', data, { headers: header, params: new HttpParams }).pipe(
  //     catchError(this.handleError));;
  // }
  ssologinValidate(): Observable<any> {
  const apiMethod = 'SSOValidateauthToken';
if (!this.ClientSideValidation(apiMethod)) {
      throw new Error(`Invalid API method: ${apiMethod}`);
    }
  // Skip validation for this method
  const data = {
    userId: sessionStorage.getItem('userId'),
    userName: sessionStorage.getItem('userName'),
    ts: sessionStorage.getItem('timestamp'),
    action: sessionStorage.getItem('action'),
    guid: sessionStorage.getItem('guid'),
  };

  let header = this.getHeader(this.apiURL_Core);
  return this._http.post<any>(this.apiURL_Core + apiMethod, data, { headers: header, params: new HttpParams() }).pipe(
    catchError(this.handleError)
  );
}
  private handleError(err: HttpErrorResponse) {
    return throwError(err.message);
  }
  public getcookiedata(key: string): any {
    var keyname = this.hash(key);
    // var setvalue = this.encrypt(value.toString());
    var getdata = cookies.get(keyname);
    if (getdata != undefined && getdata != null) {
      return this.decrypt(getdata);
    }
  }
  public hash(key: any): any {
    key = CryptoJS.SHA256(key,  this.configvalue.toString()+"90");
    return key.toString();
  }
  public decrypt(data: any) {
    data = CryptoJS.AES.decrypt(data,  this.configvalue.toString()+"90");
    data = data.toString(CryptoJS.enc.Utf8);
    return data;
  }

}

export class EmmiterService {
  private static _emmitters: { [channel: string]: EventEmitter<any> } = {};
  static get(channel: string): EventEmitter<any> {
    if (!this._emmitters[channel])
      this._emmitters[channel] = new EventEmitter();
    return this._emmitters[channel];
  }
}
